import React, { useEffect, useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { getScriptContent } from "../../../../actions/Utilities/ScriptConfiguration";
import MinusButton from "../../../../components/MinusButton";
import Modal from "../../../../components/Modal";
import PlusButton from "../../../../components/PlusButton";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import ShowButton from "../../../../components/ShowButton";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { addShowState, scriptChange } from "../atoms/atoms";
import { IReportsDetails } from "../types";
import ScriptForm from "./ScriptForm";
interface ReportsDetailProps {
  reportsDetails: Array<IReportsDetails>;
}

const ReportsDetailsForm = ({
  reportsDetails,
}: ReportsDetailProps): JSX.Element => {
  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;
  const [isShow, setIsShow] = useState(false);
  const [content, setContent] = useState("");
  const actionAddState = useRecoilValue(addShowState);
  const [reportIndex, setReportndex] = useState(0);
  const [isScriptSave, setIsScriptSave] = useState(false);
  const [addNewReport, setIsAddNewReport] = useState(false);
  const [, setIsScriptChange] = useRecoilState(scriptChange);
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name:
      reportsDetails.length > 0 && reportsDetails[0].tableName
        ? reportsDetails[0].tableName
        : "",
  });
  const tableArray = reportsDetails?.length > 0 && watch("configReports");
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
    }));
  //SETTING DEFAULT TABLE VALUES
  useEffect(() => {
    if (reportsDetails) {
      replace(reportsDetails);
    }
  }, [reportsDetails]);

  useEffect(() => {
    if (isScriptSave) {
      setValue(`configReports[${reportIndex}].script`, content);
      setIsScriptSave(false);
      setIsScriptChange(true);
    }
  }, [isScriptSave]);

  const sourceSystemOpts = [
    { value: "ConfieInquiry", label: "ConfieInquiry" },
    { value: "MaguireRepository", label: "MaguireRepository" },
    { value: "MaguireMiddleware_CIGH", label: "MaguireMiddleware_CIGH" },
    {
      value: "MaguireMiddleware_Production",
      label: "MaguireMiddleware_Production",
    },
    {
      value: "MaguireMiddleware_SPLC",
      label: "MaguireMiddleware_SPLC",
    },
    { value: "AcumaticaStg", label: "AcumaticaStg" },
    { value: "AZPXSQLConnectionString", label: "AZPXSQLConnectionString" },
  ];

  const handleShowScript = (script, index) => {
    setReportndex(index);
    if (actionAddState || addNewReport) {
      setContent(script);
      setIsAddNewReport(false);
    } else {
      setContent(script);
    }
    setIsShow(true);
  };
  return (
    <>
      {controlledFields &&
        controlledFields.map((field, index) => {
          return (
            <div className="grid sm:grid-cols-10 pb-4" key={field.id}>
              <div className="flex items-center justify-center px-2 pt-4">
                <div className={`space-y-1 w-4/5 text-xs`}>
                  {index > 0 ? (
                    <MinusButton
                      type="button"
                      onClick={() => {
                        remove(index);
                      }}
                    />
                  ) : (
                    <PlusButton
                      type="button"
                      onClick={(e) => {
                        append({
                          tableName: "configReports",
                          parentRow: false,
                        });
                        setIsAddNewReport(true);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-span-9 grid sm:grid-cols-6 content-center gap-x-2">
                <TextInputLabelHookForm
                  label={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "Reports Name"
                      : undefined
                  }
                  type="text"
                  required={
                    watch(
                      `${reportsDetails[0].tableName}[${index}].sourceSystem`
                    ) ||
                    watch(`${reportsDetails[0].tableName}[${index}].scriptPath`)
                      ? true
                      : false
                  }
                  secondDiv={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                  register={register(
                    `${reportsDetails[0].tableName}[${index}].reportName`,
                    {
                      required: {
                        value:
                          watch(
                            `${reportsDetails[0].tableName}[${index}].sourceSystem`
                          ) ||
                          watch(
                            `${reportsDetails[0].tableName}[${index}].scriptPath`
                          )
                            ? true
                            : false,
                        message: "Required Field",
                      },
                    }
                  )}
                  className={
                    errors?.[reportsDetails[0]?.tableName ?? ""] &&
                    errors?.[reportsDetails[0]?.tableName ?? ""][index]
                      ?.reportName &&
                    "border-2 border-red-500 col-span-2"
                  }
                />
                <TextInputLabelHookForm
                  label={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "Job ID"
                      : undefined
                  }
                  type="text"
                  required={false}
                  secondDiv={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                  disabled={true}
                  register={register(
                    `${reportsDetails[0].tableName}[${index}].jobConfigId`,
                    {}
                  )}
                />
                <Controller
                  control={control}
                  name={`${reportsDetails[0].tableName}[${index}].sourceSystem`}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      label={
                        index < 1 && reportsDetails[0].parentRow === true
                          ? "Source System"
                          : undefined
                      }
                      field={field}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                      }}
                      value={field.value}
                      options={sourceSystemOpts}
                      secondDiv={
                        index < 1 && reportsDetails[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      className={
                        errors?.[reportsDetails[0]?.tableName ?? ""] &&
                        errors?.[reportsDetails[0]?.tableName ?? ""][index]
                          ?.sourceSystem &&
                        "border-2 border-red-500 col-span-2"
                      }
                    />
                  )}
                />
                <TextInputLabelHookForm
                  label={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "Path"
                      : undefined
                  }
                  type="text"
                  required={false}
                  secondDiv={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                  register={register(
                    `${reportsDetails[0].tableName}[${index}].scriptPath`,
                    {}
                  )}
                  readOnly={true}
                  className={
                    errors?.[reportsDetails[0]?.tableName ?? ""] &&
                    errors?.[reportsDetails[0]?.tableName ?? ""][index]?.path &&
                    "border-2 border-red-500 col-span-2"
                  }
                />

                <div className="grid grid-cols-1 w-full items-center gap-1 text-xs">
                  {index < 1 && reportsDetails[0].parentRow === true
                    ? "Scripts"
                    : undefined}
                  <ShowButton
                    buttonText="Show"
                    className={
                      "flex space-x-1 justify-start expandedLabel fontExpand"
                    }
                    disabled={
                      watch(
                        `${reportsDetails[0].tableName}[${index}].reportName`
                      )
                        ? false
                        : true
                    }
                    onClick={(e) => {
                      handleShowScript(
                        watch(
                          `${reportsDetails[0].tableName}[${index}].script`
                        ),
                        index
                      );
                    }}
                  />
                </div>
                <TextInputLabelHookForm
                  label={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? ""
                      : undefined
                  }
                  type="hidden"
                  required={false}
                  secondDiv={
                    index < 1 && reportsDetails[0].parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                  register={register(
                    `${reportsDetails[0].tableName}[${index}].script`,
                    {}
                  )}
                  className={
                    errors?.[reportsDetails[0]?.tableName ?? ""] &&
                    errors?.[reportsDetails[0]?.tableName ?? ""][index]
                      ?.script &&
                    "border-2 border-red-500 col-span-2"
                  }
                />
              </div>
            </div>
          );
        })}
      {isShow && (
        <Modal
          isCloseHide={true}
          modalFilterStat=""
          className="w-full"
          width={"100"}
          title={""}
          isOpen={isShow}
          onClose={() => {
            setIsShow(false);
          }}
          hasCloseButton={false}
        >
          <ScriptForm
            content={content}
            setIsShow={setIsShow}
            actionAddState={actionAddState}
            setIsScriptSave={setIsScriptSave}
            setContent={setContent}
          />
        </Modal>
      )}
    </>
  );
};

export default ReportsDetailsForm;
